export const RESET = "reset";
export const CLEAN_ACCESS_TOKEN = "cleanAccessToken";
export const UPDATE_ACCESS_TOKEN = "updateAccessToken";
